// ═══════════════════════════════════════════════════════════════════════════
// Spinner — a single circular, rotating progress indicator.
//
// Used as the Suspense fallback while a lazily-loaded page chunk downloads, so
// the app shell paints immediately and fills the view in a beat later rather
// than blocking the whole bundle on one giant download. Pure-CSS rotation
// (.epio-spinner in index.css), no deps, no layout shift.
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

export default function Spinner({ size = 24, label = 'Loading', center = false }) {
  const ring = (
    <span
      className="epio-spinner"
      role="status"
      aria-label={label}
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 11)) }}
    />
  );
  return center ? <div className="epio-spinner-center">{ring}</div> : ring;
}
